﻿$.fn.dxCtrlCompteEmailConfigReception = function custom_dxCtrlCompteEmailConfigReception(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcompteemailconfigreception dx-ctrl");
        this.createInstance(new cdxCtrlCompteEmailConfigReception(this, option));
    }
    return this;
}

window.cdxCtrlCompteEmailConfigReception = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var lstCtrl = []
    var lstElem = []
    var dxCtrlSwitchActif = null
    var $TdAntiSpam = null;
    var dxDateDebutReception = null;
    var $TdDateDebutReception = null;
    var dxNbJourSupp = null;
    var $TdNbJourSupp1 = null;
    var $TdNbJourSupp2 = null;
    var dxBtTest = null;
    var hasPassword = null;
    //if (typeof option.newPassword == 'undefined') option.newPassword = ""

    this.isConfigOk = (option.dataCompteEmail.reception_actif == "1")
    this.hasChange = false
    var isLogged = false
    var disableChangeSwitch = false

    function mConstruit() {
        container.empty();

        if (typeof option.jauge == 'undefined') { option.jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance") }

        if (option.dataCompteEmail.id_utilisateur != option.dataCompteEmailUtilisateur.id_utilisateur && !isLogged) {
            //l'utilisateur courant ne gère pas ce compte mail
            //il est juste abonné
            //on demande le moit de passe de l'utilisateur qui est abonné
            container.css("text-align", "center")
            var objUti = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == option.dataCompteEmail.id_utilisateur })[0])
            $("<div>Cette adresse email est gérée par l'utilisateur <b>" + objUti.mGetLib1() + "</b>.<br/>Veuillez saisir son mot de passe pour accéder à l'interface de configuration de réception.</div>").appendTo(container)
            $("<br/>").appendTo(container)
            var dtxTextBoxPwd = $("<div style='display:inline-block'/>").appendTo(container).dxCtrlTextBox({
                width: 330,
                labelMode: 'floating',
                label: "Saisissez le mot de passe de l'utilisateur",
                value: option.value,
                showClearButton: false,
                placeholder: "Mot de passe",
                maxLength: 100,
                buttons: [{
                    focusStateEnabled: false,
                    name: 'showpwd',
                    location: 'after',
                    options: {
                        icon: 'eyeopen',
                        hint: "Révéler/cacher le texte",
                        focusStateEnabled: false,
                        stylingMode: 'text',
                        onClick() {
                            if (dtxTextBoxPwd.element().find("input").hasClass("txtPassword")) {
                                if (dtxTextBoxPwd.option("value") != null && dtxTextBoxPwd.option("value").contains("xxxxx")) {
                                    //Le mot de passe est en mémoire et ne peut être révélé
                                    dtxTextBoxPwd.option("value", "")
                                    mNotify("Le mot de passe en mémoire ne peut être révélé.<br/>Celui-ci a été retiré.<br/>Vous pouvez maintenant saisir votre nouveau mot de passe", "warning", 6000)
                                }
                                dtxTextBoxPwd.element().find("input").removeClass("txtPassword")
                            } else {
                                dtxTextBoxPwd.element().find("input").addClass("txtPassword")
                            }
                        },
                    },
                }],
                onContentReady: function (e) {
                    e.component.element().find("input").addClass("txtPassword")
                }
            }).dxCtrlTextBox("instance")
            $("<br/>").appendTo(container)
            $("<br/>").appendTo(container)
            $("<div/>").appendTo(container).dxCtrlButton({
                text: "Valider",
                onClick: function (e) {
                    if (dtxTextBoxPwd.option("value") == null || dtxTextBoxPwd.option("value").length == 0) {
                        if (objUti.data.is_robot == "1") {
                            isLogged = true;
                            mConstruit()
                        } else {
                            mNotify("Veuillez saisir le mot de passe de l'utilisateur.", "warning", 6000)
                            dtxTextBoxPwd.focus()
                        }
                    } else {
                        option.bddCtrl.mAjaxCall({ command: "verifutipwd", email: objUti.data.adresse_email, pwd: dtxTextBoxPwd.option("value") }, function (data) {
                            if (data.pwdok == "1") {
                                isLogged = true;
                                mConstruit()
                            } else {
                                mNotify("Le mot de passe est erroné.", "warning", 6000)
                                dtxTextBoxPwd.focus()
                            }
                        })
                    }
                }
            }).dxCtrlButton("instance")
        } else {
            container.css("text-align", "left")
            var $Table = $("<table style='width:100%;padding-bottom:20px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;vertical-align:middle;'/>").appendTo($Tr)
            dxCtrlSwitchActif = $("<div/>").appendTo($Td).dxCtrlSwitch({
                width: 55,
                value: (option.dataCompteEmail.reception_actif == "1"),
                focusStateEnabled: false,
                onValueChanged: function (e) {
                    if (disableChangeSwitch) return
                    if (e.value) {
                        if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                            //on a déjà un token
                            mValideChange()
                        } else {
                            $("<div/>").appendTo("body").dxCtrlConfigPopupPopImap({
                                bddCtrl: option.bddCtrl,
                                value: {
                                    adresse_email: option.dataCompteEmail.adresse_email,
                                    reception_login: option.dataCompteEmail.reception_login,
                                    reception_serveur: option.dataCompteEmail.reception_serveur,
                                    reception_port: option.dataCompteEmail.reception_port,
                                    reception_ssl: option.dataCompteEmail.reception_ssl,
                                    reception_is_imap: option.dataCompteEmail.reception_is_imap,
                                    reception_pwd: ((option.dataCompteEmail.reception_pwd == null) ? "" : option.dataCompteEmail.reception_pwd)
                                },
                                onValide: function (value) {
                                    Me.hasChange = true;
                                    option.dataCompteEmail.reception_login = value.reception_login
                                    option.dataCompteEmail.reception_serveur = value.reception_serveur
                                    option.dataCompteEmail.reception_port = value.reception_port
                                    option.dataCompteEmail.reception_ssl = value.reception_ssl
                                    option.dataCompteEmail.reception_is_imap = value.reception_is_imap
                                    option.dataCompteEmail.reception_pwd = value.reception_pwd
                                    mValideChange()
                                },
                                onCancel: function () {
                                    Me.mCancel()
                                },
                                onDemandeClosePopupParent: option.onDemandeClosePopupParent,
                                onDemandeConnexionOauthGmail: option.onDemandeConnexionOauthGmail
                            })
                        }
                        //var domaine = option.dataCompteEmail.adresse_email.split("@")[1]
                        //if (parametre.domaineSpam.filter(function (o) { return o.provider == "Gmail" && o.domain.contains("@" + domaine.toLowerCase()) }).length > 0) {
                        //    //on est sur un compte gmail
                        //    if (option.dataCompteEmail.access_token_oauth != null && option.dataCompteEmail.access_token_oauth.length > 0) {
                        //        //on a déjà un token
                        //        mValideChange()
                        //    } else {
                        //        disableChangeSwitch = true
                        //        e.component.option("value", false)
                        //        disableChangeSwitch = false
                        //        mCreateTokenEmailGmail({
                        //            bddCtrl: option.bddCtrl,
                        //            onStart: function () { },
                        //            onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                        //                option.dataCompteEmail = dataCompteEmail
                        //                option.dataCompteEmailUtilisateur = dataCompteEmailUtilisateur
                        //                option.dataCompteEmail.reception_actif = "1"
                        //                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_actif", function (data) {
                        //                    if (typeof option.onDemandeReloadForOAuth != 'undefined') option.onDemandeReloadForOAuth()
                        //                })
                        //            }
                        //        })
                        //    }
                        //} else {
                        //    $("<div/>").appendTo("body").dxCtrlConfigPopupPopImap({
                        //        bddCtrl: option.bddCtrl,
                        //        value: {
                        //            adresse_email: option.dataCompteEmail.adresse_email,
                        //            reception_login: option.dataCompteEmail.reception_login,
                        //            reception_serveur: option.dataCompteEmail.reception_serveur,
                        //            reception_port: option.dataCompteEmail.reception_port,
                        //            reception_ssl: option.dataCompteEmail.reception_ssl,
                        //            reception_is_imap: option.dataCompteEmail.reception_is_imap,
                        //            reception_pwd: ((option.dataCompteEmail.reception_pwd == null) ? "" : option.dataCompteEmail.reception_pwd)
                        //        },
                        //        onValide: function (value) {
                        //            Me.hasChange = true;
                        //            option.dataCompteEmail.reception_login = value.reception_login
                        //            option.dataCompteEmail.reception_serveur = value.reception_serveur
                        //            option.dataCompteEmail.reception_port = value.reception_port
                        //            option.dataCompteEmail.reception_ssl = value.reception_ssl
                        //            option.dataCompteEmail.reception_is_imap = value.reception_is_imap
                        //            option.dataCompteEmail.reception_pwd = value.reception_pwd
                        //            mValideChange()
                        //        },
                        //        onCancel: function () {
                        //            disableChangeSwitch = true
                        //            dxCtrlSwitchActif.option("value", false)
                        //            disableChangeSwitch = false
                        //        },
                        //        onDemandeClosePopupParent: option.onDemandeClosePopupParent,
                        //        onDemandeConnexionOauthGmail: option.onDemandeConnexionOauthGmail
                        //    })
                        //}
                    } else {
                        mValideChange()
                    }

                    function mValideChange() {
                        Me.hasChange = true;
                        option.dataCompteEmail.reception_actif = ((e.value) ? "1" : "0")
                        if (option.allowSave) {
                            option.jauge.mShow()
                            if (option.dataCompteEmail.id_compte_email == null) {
                                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_actif", function (data) {
                                    option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_login", function (data) {
                                        option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_serveur", function (data) {
                                            option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_port", function (data) {
                                                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_ssl", function (data) {
                                                    option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_is_imap", function (data) {
                                                        option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_pwd", function (data) {
                                                            if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                                            option.jauge.mHide()
                                                            mConstruit()
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            } else {
                                if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                                    option.bddCtrl.mAjaxCall({
                                        command: "savecompteemailreception",
                                        id_compte_email: option.dataCompteEmail.id_compte_email,
                                        reception_actif: option.dataCompteEmail.reception_actif
                                    }, function (data) {
                                        option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "modif", option.dataCompteEmail)
                                        if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                        option.jauge.mHide()
                                        mConstruit()
                                    })
                                } else {
                                    option.bddCtrl.mAjaxCall({
                                        command: "savecompteemailreception",
                                        id_compte_email: option.dataCompteEmail.id_compte_email,
                                        reception_actif: option.dataCompteEmail.reception_actif,
                                        reception_login: option.dataCompteEmail.reception_login,
                                        reception_serveur: option.dataCompteEmail.reception_serveur,
                                        reception_port: option.dataCompteEmail.reception_port,
                                        reception_ssl: option.dataCompteEmail.reception_ssl,
                                        reception_is_imap: option.dataCompteEmail.reception_is_imap,
                                        reception_pwd: option.dataCompteEmail.reception_pwd
                                    }, function (data) {
                                        option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "modif", option.dataCompteEmail)
                                        if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                        option.jauge.mHide()
                                        mConstruit()
                                    })
                                }
                            }
                        } else {
                            if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                            mConstruit()
                        }
                    }
                    //Me.isConfigOk = false
                    //if (option.allowSave) {
                    //    if (e.value) { $DivNeedVerif.show() }
                    //    else { $DivNeedVerif.hide() }
                    //}
                    //option.dataCompteEmail.reception_actif = ((e.value) ? "1" : "0")
                    //mActive()
                    //if (option.allowSave) mSaveChamp(option.dataCompteEmail, "reception_actif");
                    //if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                }
            }).dxCtrlSwitch("instance")
            var $Td = $("<td style='width:100%;padding-left:10px;vertical-align:middle;'>Réception des emails sur ce compte</td>").appendTo($Tr)

            if (option.dataCompteEmail.reception_actif == "0") {
                $("<div style='color:orange;font-weight:bold;'>Vous n'avez pas activé la réception des messages sur cette adresse email.</div>").appendTo(container)
            } else {
                var items = [];
                items.push({
                    label: { visible: false, text: "login", location: "left" },
                    template: function (itemData, itemElement) {
                        var $Div = $("<div style='margin:0;padding:10px;border:" + theme.border + ";'/>").appendTo(itemElement)

                        if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                            $("<div>Vous êtes connecté via <b>OAuth</b>. L’accès à votre boîte mail est sécurisé : votre mot de passe n’est jamais stocké ni partagé.</div>").appendTo($Div)
                            var $Table = $("<table style='margin-bottom:5px;'/>").appendTo($Div)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $Td = $("<td style='width:100%;opacity:0.5;'></td>").appendTo($Tr)
                            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Tester</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                mTestConnexionOauth()
                            })
                            //var $Td = $("<td style='width:1px;padding-right:15px;'></td>").appendTo($Tr)
                            //var $A = $("<a href='javascript:void(0)'>Supprimer</a>").appendTo($Td)
                            //$A.on("click", function (e) {
                            //    mTestConnexionOauth()
                            //})
                            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Déconnecter</a>").appendTo($Td)
                            $A.on("click", function () {
                                option.dataCompteEmail.access_token_oauth = null
                                option.dataCompteEmail.refresh_token_oauth = null
                                option.dataCompteEmail.type_token_oauth = null
                                option.dataCompteEmail.envoi_actif = "0"
                                option.dataCompteEmail.reception_actif = "0"
                                option.dataCompteEmail.access_token_oauth_crypt = null
                                option.dataCompteEmail.refresh_token_oauth_crypt = null
                                option.bddCtrl.getObjet(option.dataCompteEmail).mSave(function (data) {
                                    if (typeof option.onDemandeReloadForOAuth != 'undefined') option.onDemandeReloadForOAuth()
                                })
                            })
                        } else {
                            var $Table = $("<table style='margin-bottom:5px;'/>").appendTo($Div)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $Td = $("<td style='width:100%;opacity:0.5;'>Configuration de la réception</td>").appendTo($Tr)                                
                            var $Td = $("<td style='width:1px;padding-right:15px;'></td>").appendTo($Tr)
                            var $Td = $("<td style='width:1px;padding-right:15px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Tester</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                mTestConnexionImapPop()
                            })
                            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Modifier</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                $("<div/>").appendTo("body").dxCtrlConfigPopupPopImap({
                                    bddCtrl: option.bddCtrl,
                                    value: {
                                        adresse_email: option.dataCompteEmail.adresse_email,
                                        reception_login: option.dataCompteEmail.reception_login,
                                        reception_serveur: option.dataCompteEmail.reception_serveur,
                                        reception_port: option.dataCompteEmail.reception_port,
                                        reception_ssl: option.dataCompteEmail.reception_ssl,
                                        reception_is_imap: option.dataCompteEmail.reception_is_imap,
                                        reception_pwd: ((option.dataCompteEmail.reception_pwd == null) ? "" : option.dataCompteEmail.reception_pwd)
                                    },
                                    onValide: function (value) {
                                        Me.hasChange = true;
                                        option.dataCompteEmail.reception_login = value.reception_login
                                        option.dataCompteEmail.reception_serveur = value.reception_serveur
                                        option.dataCompteEmail.reception_port = value.reception_port
                                        option.dataCompteEmail.reception_ssl = value.reception_ssl
                                        option.dataCompteEmail.reception_is_imap = value.reception_is_imap
                                        option.dataCompteEmail.reception_pwd = value.reception_pwd
                                        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSave()
                                    },
                                    onDemandeClosePopupParent: option.onDemandeClosePopupParent
                                })
                            })
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Login: </span>" + option.dataCompteEmail.reception_login + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Serveur: </span>" + option.dataCompteEmail.reception_serveur + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Type: </span>" + ((option.dataCompteEmail.reception_is_imap == "1") ? "IMAP" : "POP") + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Port: </span>" + option.dataCompteEmail.reception_port + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>SSL: </span>" + ((option.dataCompteEmail.reception_ssl == "1") ? "OUI" : "NON") + "</div>").appendTo($Div)
                        }
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })
                items.push({
                    label: { visible: false, text: "antispam", location: "left" },
                    template: function (itemData, itemElement) {
                        itemElement.css("padding-top", "20px")
                        var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                        //$Table.attr("title", "Pour tous les destinataires qui vous envoient un email,<br/>qui ne sont pas dans votre base de données,<br/>qui vous écrivent pour la première fois ou<br/>à qui vous n'avez jamais écrit,   <br/>recevront un email demandant de confirmer leur envoi en saisissant un code.<br/><br/>Tant que le code ne sera pas saisie<br/>l'email se trouvera en attente dans vos SPAM<br/>où vous pourrez le consulter.")
                        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Table, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Pour tous les destinataires qui vous envoient un email,<br/>qui ne sont pas dans votre base de données,<br/>qui vous écrivent pour la première fois ou<br/>à qui vous n'avez jamais écrit,   <br/>recevront un email demandant de confirmer leur envoi en saisissant un code.<br/><br/>Tant que le code ne sera pas saisie<br/>l'email se trouvera en attente dans vos SPAM<br/>où vous pourrez le consulter.</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px;vertical-align:middle;'/>").appendTo($Tr)
                        lstCtrl.push($("<div/>").appendTo($Td).dxCtrlSwitch({
                            width: 55,
                            value: (option.dataCompteEmail.reception_date_antispam != null),
                            focusStateEnabled: false,
                            onValueChanged: function (e) {
                                //option.dataCompteEmail.reception_anti_spam_actif = ((e.value) ? "1" : "0")
                                //Me.hasChange = true;
                                //if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_date_antispam");
                                //if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                if (e.value) {
                                    //on précise pour confirmation
                                    var validate = false
                                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                        target: e.component.element(),
                                        shading: true,
                                        contentTemplate: function (contentElement) {
                                            contentElement.css("padding", "20px")
                                            $("<div>" +
                                                "Lorsque vous activez le filtre anti-spam, tous les expéditeurs inconnus<br/>" + 
                                                "(c’est-à-dire ceux qui ne figurent pas dans vos adresses validées, à qui vous n’avez jamais écrit,<br/>ou qui ne sont pas enregistrés dans votre base de données)<br/>" +
                                                "verront leurs messages classés automatiquement en SPAM.<br/>" +
                                                "<br/>" +
                                                "Ils recevront alors un e-mail les invitant à cliquer sur un lien.<br/>"  +
                                                "pour confirmer que leur message vous est bien destiné (et qu’ils ne sont pas un robot).<br/>" +
                                                "Après avoir cliqué sur ce lien et résolu un petit puzzle très simple,<br/>" +
                                                "leur message sera déplacé dans votre boîte de réception.<br/>" +
                                                "<br/>" +
                                                "L’expéditeur sera ensuite ajouté à votre liste de correspondants de confiance,<br/>" +
                                                "et tous ses futurs messages seront directement classés en boîte de réception.<br/>" +
                                                "<br/>" +
                                                "⚠️ Si vous marquez un message comme SPAM, l’adresse de l’expéditeur sera bloquée<br/>" +
                                                "et tous ses futurs e-mails seront automatiquement classés en SPAM (sauf si vous le retirez des SPAM)." +
                                                "</div>").appendTo(contentElement)
                                            $("<div style='margin-top:20px;width:100%;'/>").appendTo(contentElement).dxCtrlButton({
                                                text: "Confirmez l'activation",
                                                onClick: function (e) {
                                                    mSaveAntiSpam()
                                                    validate = true
                                                    tt.hide()
                                                }
                                            })
                                        },
                                        onHiding: function (ee) {
                                            if (!validate) { e.component.option("value", false) }
                                        }
                                    }).dxCtrlTooltip("instance")
                                    tt.show()
                                } else {
                                    mSaveAntiSpam()
                                }

                                function mSaveAntiSpam() {
                                    Me.hasChange = true;
                                    option.dataCompteEmail.reception_date_antispam = ((e.value) ? parametre.dateNow : null)
                                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_date_antispam");
                                    if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                }
                            }
                        }).dxCtrlSwitch("instance"))
                        $TdAntiSpam = $("<td style='width:100%;padding-left:10px;font-size:14px;'>Activer le filtre anti-SPAM</td>").appendTo($Tr)
                        lstElem.push($TdAntiSpam)
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })
                items.push({
                    label: { visible: false, text: "data_reception", location: "left" },
                    template: function (itemData, itemElement) {
                        itemElement.attr("title", "L'application récupérera seulement les messages reçu après la date de réception.")
                        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: itemElement, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>L'application récupérera seulement les messages reçu aprés la date de réception.</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
                        var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px;vertical-align:middle;'/>").appendTo($Tr)
                        lstCtrl.push($("<div/>").appendTo($Td).dxCtrlSwitch({
                            width: 55,
                            value: (option.dataCompteEmail.reception_date_debut != null),
                            focusStateEnabled: false,
                            onValueChanged: function (e) {
                                Me.hasChange = true;
                                option.dataCompteEmail.reception_date_debut = ((e.value) ? new Date() : null)
                                dxDateDebutReception.option("value", option.dataCompteEmail.reception_date_debut)
                                if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_date_debut");
                                if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                            }
                        }).dxCtrlSwitch("instance"))
                        $TdDateDebutReception = $("<td style='width:1px;white-space:nowrap;padding-left:10px;font-size:14px;text-align:right;'>Date début<br/>réception:</td>").appendTo($Tr)
                        lstElem.push($TdDateDebutReception)
                        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                        dxDateDebutReception = $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlDateBox({
                            width: "100%",
                            labelMode: 'floating',
                            label: "Date début",
                            type: 'date',
                            max: new Date(),
                            value: option.dataCompteEmail.reception_date_debut,
                            onValueChanged: function (e) {
                                Me.hasChange = true;
                                option.dataCompteEmail.reception_date_debut = e.value
                                if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("reception_date_debut");
                                if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                            }
                        }).dxCtrlDateBox("instance")
                        lstCtrl.push(dxDateDebutReception)
                        var $Td = $("<td style='width:100%;'></td>").appendTo($Tr)
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })

                var $DivForm = $("<div style='position:relative;'/>").appendTo(container)
                var form = $("<div style='padding:0 65px;'/>").appendTo($DivForm).dxCtrlForm({
                    labelMode: 'floating',
                    showColonAfterLabel: true,
                    labelLocation: 'left',
                    items: items
                }).dxCtrlForm("instance");
            }
        }
    }

    //function mSaveChamp(data, nomChamp) {
    //    option.bddCtrl.getObjet(data).mSaveChamp(nomChamp)
    //}

    this.mCancel = function () {
        disableChangeSwitch = true
        dxCtrlSwitchActif.option("value", false)
        disableChangeSwitch = false
    }

    this.mSave = function (data) {
        option.bddCtrl.getObjet(data).mSave()
    }

    function mTestConnexionOauth() {
        option.jauge.mShow()
        var reqAjax = option.bddCtrl.mAjaxCall({
            command: "testemailoauth",
            id_compte_email: option.dataCompteEmail.id_compte_email
        }, function (data) {
            if (typeof data.message_erreur != 'undefined' && data.message_erreur.length > 0) {
                mNotify("Votre connexion oauth ne fonctionne plus<br>Pour réactiver votre connexion, déconnecter vous et reconnecter vous au service.<br/><i>" + data.message_erreur + "</i>", "error", 12000)
            } else {
                mNotify("Votre connexion oauth est active", "success", 12000)
            }
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
        }, function () {
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
            option.jauge.mHide()
        });
    }

    function mTestConnexionImapPop() {
        debugger; //1
        Me.isConfigOk = false
        option.jauge.mShow()
        option.jauge.option("message", "Vérification de vos paramètres de réception")
        option.jauge.option("onCancel", function () {
            reqAjax.abort()
            if (typeof option.onErreurTestConnexion != 'undefined') option.onErreurTestConnexion()
        })
        var reqAjax = option.bddCtrl.mAjaxCall({
            command: ((option.dataCompteEmail.reception_is_imap == "1") ? "testemailimap" : "testemailpop"),
            server: option.dataCompteEmail.reception_serveur,
            port: option.dataCompteEmail.reception_port,
            ssl: option.dataCompteEmail.reception_ssl,
            login: option.dataCompteEmail.reception_login,
            adresse_email: option.dataCompteEmail.adresse_email,
            pwd: option.dataCompteEmail.reception_pwd,
            utilise_pwd_bdd: ((option.dataCompteEmail.reception_pwd == null || option.dataCompteEmail.reception_pwd.length == 0) ? "1" : "0")
        }, function (data) {
            if (typeof data.message_erreur != 'undefined') {
                var txt = ""
                var txt = ""
                if (!data.message_erreur.contains("(1265)")) {
                    txt = "<br/>Si vous ne connaissez pas la configuration de votre adresse email, demander à votre hébergeur les paramètres du POP/IMAP de votre adresse email."
                }
                txt = "Les paramètres de connexion que vous avez saisie sont incorrecte:<br/>" + "&bull; " + data.message_erreur.replace(" (1265)", "") + txt
                if (typeof option.dataCompteEmail.reception_serveur != 'undefined' && option.dataCompteEmail.reception_serveur && option.dataCompteEmail.reception_serveur.endsWith(".gmail.com")) {
                    txt += "<br/><a href='#' onClick='mShowHelpConnexionGmail();return false;' target='_blank' style='color:white'>Pour GMAIL, vous devez intervenir sur votre compte pour créer un mot de passe d'application</a>"
                }
                mNotify(txt, "error", 12000)
                dxCtrlSwitchActif.option("value", false)
            } else {
                mNotify("La configuration que vous avez saisie est correcte", "success", 12000)
            }
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
        }, function () {
            option.jauge.mHide()
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
            //dxWizard.mNext(true)
        });
    }
    //this.mTestConnexionImapPop = function (funcOk, funcKo) {
    //    debugger; //1
    //    Me.isConfigOk = false
    //    option.jauge.mShow()
    //    option.jauge.option("message", "Vérification de vos paramètres de réception")
    //    option.jauge.option("onCancel", function () {
    //        reqAjax.abort()
    //        if (typeof option.onErreurTestConnexion != 'undefined') option.onErreurTestConnexion()
    //    })
    //    var reqAjax = option.bddCtrl.mAjaxCall({
    //        command: ((option.dataCompteEmail.reception_is_imap == "1") ? "testemailimap" : "testemailpop"),
    //        server: option.dataCompteEmail.reception_serveur,
    //        port: option.dataCompteEmail.reception_port,
    //        ssl: option.dataCompteEmail.reception_ssl,
    //        login: option.dataCompteEmail.reception_login,
    //        adresse_email: option.dataCompteEmail.adresse_email,
    //        pwd: option.dataCompteEmail.reception_pwd,
    //        utilise_pwd_bdd: ((option.dataCompteEmail.reception_pwd == null || option.dataCompteEmail.reception_pwd.length == 0) ? "1" : "0")
    //    }, function (data) {
    //        if (typeof data.message_erreur != 'undefined') {
    //            var txt = ""
    //            var txt = ""
    //            if (!data.message_erreur.contains("(1265)")) {
    //                txt = "<br/>Si vous ne connaissez pas la configuration de votre adresse email, demander à votre hébergeur les paramètres du POP/IMAP de votre adresse email."
    //            }
    //            txt = "Les paramètres de connexion que vous avez saisie sont incorrecte:<br/>" + "&bull; " + data.message_erreur.replace(" (1265)", "") + txt
    //            if (typeof option.dataCompteEmail.reception_serveur != 'undefined' && option.dataCompteEmail.reception_serveur && option.dataCompteEmail.reception_serveur.endsWith(".gmail.com")) {
    //                txt += "<br/><a href='#' onClick='mShowHelpConnexionGmail();return false;' target='_blank' style='color:white'>Pour GMAIL, vous devez intervenir sur votre compte pour créer un mot de passe d'application</a>"
    //            }
    //            mNotify(txt, "error", 12000)
    //            dxCtrlSwitchActif.option("value", false)
    //        } else {
    //            mNotify("La configuration que vous avez saisie est correcte", "success", 12000)
    //        }
    //        option.jauge.option("message", null)
    //        option.jauge.option("onCancel", null)
    //    }, function () {
    //        option.jauge.mHide()
    //        option.jauge.option("message", null)
    //        option.jauge.option("onCancel", null)
    //        //dxWizard.mNext(true)
    //    });
    //}

    this.mMigreData = function (data) {
        data.reception_login = option.dataCompteEmail.reception_login
        //if (option.newPassword) { data.reception_pwd = option.newPassword; hasPassword = true; } else { delete data.reception_pwd }
        //option.newPassword = ""
        data.reception_serveur = option.dataCompteEmail.reception_serveur
        data.reception_port = option.dataCompteEmail.reception_port
        data.reception_ssl = option.dataCompteEmail.reception_ssl
        data.reception_is_imap = option.dataCompteEmail.reception_is_imap
        data.reception_pwd = option.dataCompteEmail.reception_pwd
        data.reception_nb_jour_supp = option.dataCompteEmail.reception_nb_jour_supp
        data.reception_date_debut = option.dataCompteEmail.reception_date_debut
        data.reception_date_antispam = option.dataCompteEmail.reception_date_antispam
        data.reception_actif = option.dataCompteEmail.reception_actif
        this.hasChange = false
    }

    //function mActive() {
    //    lstCtrl.forEach(function (ctrl) { ctrl.option("disabled", option.dataCompteEmail.reception_actif == "0") })
    //    lstElem.forEach(function (elem) { elem.css("color", ((option.dataCompteEmail.reception_actif == "0") ? theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)") : "")) })
    //    if (option.dataCompteEmail.reception_actif == "1" && option.dataCompteEmail.reception_date_antispam == null) {
    //        $TdAntiSpam.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)"))
    //    }
    //    if (option.dataCompteEmail.reception_actif == "1" && option.dataCompteEmail.reception_date_debut == null) {
    //        dxDateDebutReception.option("disabled", true)
    //        $TdDateDebutReception.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)"))
    //    }
    //    if (option.dataCompteEmail.reception_actif == "1" && option.dataCompteEmail.reception_nb_jour_supp == null) {
    //        dxNbJourSupp.option("disabled", true)
    //        $TdNbJourSupp1.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)"))
    //        $TdNbJourSupp2.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.2)"))
    //    }
    //    dxBtTest.option("disabled", option.dataCompteEmail.reception_actif == "0")
    //}

    this.element = function () { return container }

    mConstruit();
}

window.mShowHelpConnexionGmail = function () {
    //Cas particulier de gmail
    //on précise comment utiliser les mot de passe d'application
    notify.mShow({
        message: function (contentElement, popup) {
            contentElement.css("font-size", "110%")
            $("<div>Pour vous connecter à un compte gmail, vous devez créer un <b>mot de passe d'application</b> sur votre compte gmail.</div>").appendTo(contentElement)
            $("<div>Vous pourrez trouver des informations sur cette démarche <a href='https://support.google.com/mail/answer/185833?hl=fr' target='_blank'>ici</a>.</div>").appendTo(contentElement)
            $("<br/>").appendTo(contentElement)
            $("<br/>").appendTo(contentElement)
            var $Div = $("<div style='font-size:70%;font-style:italic;line-height:1.3;'/>").appendTo(contentElement)
            $("<table style='padding-top:8px;'><tr><td style='width:1px;color:" + theme.backgroundcolorAccent + ";font-style:normal;vertical-align:top;font-size:200%;font-weight:bold;'>➀</td><td style='width:100%;'>Pour résumé, vous devez vous rendre sur le paramètrage de la <a href='https://myaccount.google.com/security' target='_blank'/>sécurité de votre compte google</a></td></tr></table>").appendTo($Div)
            $("<table style='padding-top:8px;'><tr><td style='width:1px;color:" + theme.backgroundcolorAccent + ";font-style:normal;vertical-align:top;font-size:200%;font-weight:bold;'>➁</td><td style='width:100%;'>Avant de pouvoir accéder au mot de passe d'application, si ce n'est pas déjà fait, il faut que vous activiez la <a href='https://myaccount.google.com/signinoptions/two-step-verification' target='_blank'>validation en deux étapes</a> sur votre compte gmail pour mieux protéger votre compte.</td></tr></table>").appendTo($Div)
            $("<table style='padding-top:8px;'><tr><td style='width:1px;color:" + theme.backgroundcolorAccent + ";font-style:normal;vertical-align:top;font-size:200%;font-weight:bold;'>➂</td><td style='width:100%;'>Une fois cela fait, vous pouvez vous rendre sur la <a href='https://myaccount.google.com/apppasswords' target='_blank'>liste de vos mot de passe d'application</a> (Si vous n'y avez pas accès, c'est que vous n'avez pas la <a href='https://myaccount.google.com/signinoptions/two-step-verification' target='_blank'>validation en deux étapes</a> sur votre compte gmail).</td></tr></table>").appendTo($Div)
            $("<table style='padding-top:8px;'><tr><td style='width:1px;color:" + theme.backgroundcolorAccent + ";font-style:normal;vertical-align:top;font-size:200%;font-weight:bold;'>➃</td><td style='width:100%;'>Choisissez <b>Autre</b> pour l'application puis saisissez le nom de l'application et cliquez ensuite sur <b>Générer</b>.</td></tr></table>").appendTo($Div)
            $("<table style='padding-top:8px;'><tr><td style='width:1px;color:" + theme.backgroundcolorAccent + ";font-style:normal;vertical-align:top;font-size:200%;font-weight:bold;'>➄</td><td style='width:100%;'>Gmail vous propose un mot de passe de 16 lettres (que vous ne pouvez pas modifier). Copier ce mot de passe et utilisez le comme mot de passe pour la réception et l'envoi de mail dans l'application.</td></tr></table>").appendTo($Div)
        },
        titre: "Connexion gmail",
        img: "<i class='fas fa-exclamation-triangle' style='font-size:50px'/>",
        tempoSeconde: 30
    });
}